var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-table-layout',[_c('div',{attrs:{"slot":"mainContent"},slot:"mainContent"},[_vm._v(" Here follows the help section... ")])])}
var staticRenderFns = []

export { render, staticRenderFns }